import { DatePicker as AntdDatePicker } from "antd";
import "./style.scss";
import { DatePickerIcon } from "assets/icons";

function DatePicker({
  onChange,
  label,
  className,
  format = "DD/MM/YYYY",
  popupClassName,
  placeholder = "Select Date",
  wrapperClass,
  labelClass,
  value,
  disabledDate,
  defaultValue,
  isDisabled,
}) {
  return (
    <div className={`custom-date-picker ${wrapperClass ? wrapperClass : ""}`}>
      {label && (
        <label
          className={`date-picker-label input-label ${labelClass ? labelClass : ""}`}
        >
          {label}
        </label>
      )}
      <AntdDatePicker
        disabled={isDisabled}
        value={value}
        suffixIcon={<DatePickerIcon />}
        className={`date-picker ${className}`}
        popupClassName={`custom-datepicker-dropdown ${popupClassName}`}
        placeholder={placeholder}
        onChange={onChange}
        format={format}
        disabledDate={disabledDate}
        defaultPickerValue={defaultValue}
        onFocus={(e) => e.target.blur()}
      />
    </div>
  );
}

export default DatePicker;
